export default {
  dismissText: 'Avbryt'
};
